"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PartnersPayDetailsListCtl = /** @class */ (function (_super) {
    __extends(PartnersPayDetailsListCtl, _super);
    function PartnersPayDetailsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_login; });
        _this.dk_account = UIUtils_1.UIUtils.IProp2Str(function (o) { o.account; });
        _this.dk_app_payout_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_payout_id; });
        _this.dk_app_payout_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_payout_title; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    PartnersPayDetailsListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    PartnersPayDetailsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "partner pay details with id [" + id + "] not found !";
    };
    PartnersPayDetailsListCtl.prototype.LoadData = function (partnerId, onDone) {
        var _this = this;
        webAApi_1.ListPProgramPartnersPayDetailsGet.exec({ usr_partner_id: partnerId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    partner_login: resp.list[i].partner_login,
                    account: resp.list[i].account,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    app_payout_id: resp.list[i].app_payout_id,
                    app_payout_title: resp.list[i].app_payout_title,
                    app_currency_title: resp.list[i].app_currency_title
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersPayDetailsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgramPartnerPayDetails.exec({
            data: {
                app_payout_id: data.app_payout_id,
                usr_partner_id: data.usr_partner_id,
                account: data.account
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_payout_id: data.app_payout_id,
                app_payout_title: resp.app_payout_title,
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                partner_login: resp.partner_login,
                account: data.account,
                app_currency_title: resp.app_currency_title
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersPayDetailsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPProgramPartnerPayDetails.exec({
                data: {
                    usr_partner_paydetail_id: data.key,
                    app_payout_id: data.app_payout_id,
                    account: data.account
                }
            }, function (resp) {
                _tmp.app_payout_id = data.app_payout_id;
                _tmp.app_payout_title = resp.app_payout_title;
                _tmp.app_currency_title = resp.app_currency_title;
                _tmp.account = data.account;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PartnersPayDetailsListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PartnersPayDetailsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePProgramPartrnerPayDetails.exec({
                data: {
                    usr_partner_paydetail_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PartnersPayDetailsListCtl;
}(BaseController_1.BaseController));
exports.PartnersPayDetailsListCtl = PartnersPayDetailsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ctl/PartnersPayDetailsListCtl.ts
// module id = 995
// module chunks = 0